import { OnChangeScreen } from "./lib/warning";
import { HUD } from "./scenes/ HUD";
import { Boot } from "./scenes/Boot";
import { Game as MainGame } from "./scenes/Game";
import { GameOver } from "./scenes/GameOver";
import { MainMenu } from "./scenes/MainMenu";
import { Preloader } from "./scenes/Preloader";
import SequencePlugin from "phaser3-rex-plugins/plugins/sequence-plugin.js";

import { Game, Types } from "phaser";

//  Find out more information about the Game Config at:
//  https://newdocs.phaser.io/docs/3.70.0/Phaser.Types.Core.GameConfig

const config: Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 1920,
  height: 1080,
  parent: "game-container",
  backgroundColor: "#028af8",
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  plugins: {
    global: [
      {
        key: "rexSequence",
        plugin: SequencePlugin,
        start: true,
      },
    ],
  },
  scene: [Boot, Preloader, MainMenu, MainGame, HUD, GameOver],
};
///////////// LandScape ///////////////
const game = new Game(config);

OnChangeScreen(game);
let _orientation =
  screen.orientation || screen.mozOrientation || screen.msOrientation;

_orientation.addEventListener("change", function () {
  OnChangeScreen(game);
});
window.addEventListener("resize", function () {
  OnChangeScreen(game);
});

export default game;
